/**
 * `M` — the loupe (§3.2 `Magnifier.tsx`). It is *held*, not toggled: the
 * canvas shows a 200×200 window at 4× around the cursor so a vertex can be
 * placed on a one-pixel edge. The handler itself owns no state; the machine
 * stays `idle` and `Magnifier.tsx` reads the cursor from the canvas.
 */
import { none, type ToolHandler, type ToolResult } from './types'

/** Magnification inside the loupe. */
export const MAGNIFIER_ZOOM = 4
/** Loupe size in CSS pixels. */
export const MAGNIFIER_SIZE = 200

export const magnifierTool: ToolHandler = {
  id: 'magnifier',
  shortcut: 'm',
  icon: 'Search',
  label: 'Magnify',
  hint: 'Hold M and move the mouse to see the picture close up.',
  cursor: 'zoom-in',

  reduce(machine, ev): ToolResult | null {
    // Swallow pointer gestures so a held loupe never edits by accident.
    if (ev.t === 'pointerdown' || ev.t === 'pointermove' || ev.t === 'pointerup' || ev.t === 'dblclick') return none(machine)
    return null
  },
}
